define('lq/events/actions/saveMorph',[
    'lq/events/actions/eventAction',
    'underscore'
], function (EventAction, _) {
    'use strict';

    function SaveMorph(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
    }

    EventAction.extend(SaveMorph, EventAction);

    SaveMorph.typeName = 'SaveMorph';

    SaveMorph.prototype.getBatchType = function () {
        return EventAction.COMMAND_BATCH;
    };

    SaveMorph.prototype.createEventActionRequest = function () {
        var drop = this.piping.dropFactory.findDropById(this.eventData.saveableMorphId);
        return drop.getBatchOfCommands();
    };

    SaveMorph.prototype.execute = function (continuation, eventActionResponse) {
        var drop = this.piping.dropFactory.findDropById(this.eventData.saveableMorphId);

        if (drop.receiveBatchOfCommandsResult)
            drop.receiveBatchOfCommandsResult(eventActionResponse.identifiers);

        continuation();
    };

    return SaveMorph;
});
